import { render, staticRenderFns } from "./MatchSideItem.vue?vue&type=template&id=911a24da&scoped=true&"
import script from "./MatchSideItem.vue?vue&type=script&lang=js&"
export * from "./MatchSideItem.vue?vue&type=script&lang=js&"
import style0 from "./MatchSideItem.vue?vue&type=style&index=0&id=911a24da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911a24da",
  null
  
)

export default component.exports